import { Link } from "react-router-dom"
import Seo from "@/components/Seo"
import { useState } from "react"
import { WhatsAppButtons } from "@/components/WhatsAppButtons"

const IMGS = {
  minnesota:
    "/website-assets/images/photo-1585168121124-bc4c43c0251b-1000x700.jpg",
  kampala:
    "/website-assets/images/photo-1675756261486-09bd1e0f6c8a-1000x700.jpg",
  toronto:
    "/website-assets/images/photo-1517935706615-2717063c2225-1000x700.jpg",
}

const LOCATIONS = [
  {
    id: "usa",
    flag: "🇺🇸",
    label: "USA — HEADQUARTERS",
    city: "Minnesota",
    country: "United States",
    type: "Global Headquarters",
    img: IMGS.minnesota,
    address: "13875 Chestnut Dr, Ste 318, Eden Prairie, MN 55344, USA",
    phone: "+1682-461-4255",
    email: "info@jero-onetechnologies.com",
    hours: "Mon–Fri, 8:00 AM – 6:00 PM CST",
    desc: "Our global headquarters in the heart of the Twin Cities. Home to our executive leadership, cloud engineering teams, and North American enterprise sales operations.",
    services: [
      "Cloud Architecture",
      "Enterprise Consulting",
      "Cybersecurity SOC",
      "Managed IT Services",
    ],
    accent: "#1B5E35",
  },
  {
    id: "uganda",
    flag: "🇺🇬",
    label: "UGANDA — EAST AFRICA",
    city: "Kampala",
    country: "Uganda",
    type: "Franchise Office",
    img: IMGS.kampala,
    address: "Downtown Entebbe, Entebbe Town · P.O. Box 171736, Kampala GPO, Uganda",
    phone: "+256 766 553 449 · +256 701 511 262 · +256 752 200 865",
    email: "info@jero-onetechnologies.com · support@jero-onetechnologies.com",
    hours: "Mon–Fri, 8:00 AM – 6:00 PM EAT",
    desc: "Our East African franchise hub. Serving Uganda, Kenya, Tanzania, Rwanda, Ethiopia, and beyond with local expertise and regional connectivity.",
    services: [
      "Network Infrastructure",
      "Hardware Supply",
      "Government IT Projects",
      "Training & Support",
    ],
    accent: "#C9A84C",
  },
  {
    id: "canada",
    flag: "🇨🇦",
    label: "CANADA — NORTH AMERICA",
    city: "Canada",
    country: "Canada",
    type: "Franchise Office",
    img: IMGS.toronto,
    address: "Canada (Location details available on request)",
    phone: "",
    email: "info@jero-onetechnologies.com",
    hours: "Mon–Fri, 8:00 AM – 6:00 PM EST/PST",
    desc: "Our Canadian franchise serves businesses across Canada with the full Jero-One service portfolio, backed by the same global standards as our US headquarters.",
    services: [
      "Cloud Solutions",
      "Managed IT Services",
      "Cybersecurity",
      "IT Consulting",
    ],
    accent: "#CC0000",
  },
]

export function Locations() {
  const [active, setActive] = useState("usa")
  const loc = LOCATIONS.find((l) => l.id === active)

  return (
    <div style={{ fontFamily: "'Barlow', sans-serif" }}>
      <Seo title="Our Offices: Entebbe Uganda, Minnesota USA & Canada | Jero-One" description="Visit Jero-One Technologies in Downtown Entebbe (Kampala), Eden Prairie Minnesota and Canada. Phone numbers, addresses and service areas." path="/locations" />
      {/* Hero */}
      <section className="grid md:grid-cols-2 min-h-[50vh]">
        <div className="bg-[#0A0F0B] flex flex-col justify-center px-8 md:px-16 py-16">
          <div className="text-xs text-[#1B5E35] font-mono tracking-widest mb-4">
            WHERE WE ARE
          </div>
          <h1
            className="text-6xl font-black text-[#F4F6F0] leading-none mb-6"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            3 OFFICES.
            <br />
            <span style={{ color: "#1B5E35" }}>3 CONTINENTS.</span>
            <br />1 COMPANY.
          </h1>
          <p className="text-[#6B7C6E] leading-relaxed max-w-md">
            Jero-One Technologies Inc. operates globally with a headquarters in
            the United States and franchise offices in Uganda and Canada —
            giving our clients local support with global backing.
          </p>
        </div>
        <div className="bg-[#111A14] relative overflow-hidden min-h-48">
          {/* Simple world map dots visual */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="relative w-full h-full">
              <img fetchPriority="high"
                src={IMGS.minnesota}
                alt="Global offices"
                className="w-full h-full object-cover opacity-30"
              />
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(to right, #0A0F0B 0%, transparent 30%)",
                }}
              />
            </div>
          </div>
          {/* Floating location pins */}
          <div className="absolute inset-0 flex items-center justify-center gap-8">
            {LOCATIONS.map((l) => (
              <button
                key={l.id}
                onClick={() => setActive(l.id)}
                className={`flex flex-col items-center gap-1 transition-all ${
                  active === l.id ? "scale-125" : "opacity-60 hover:opacity-100"
                }`}
              >
                <span className="text-3xl">{l.flag}</span>
                <span className="text-[10px] text-[#F4F6F0] font-mono tracking-wider">
                  {l.city.toUpperCase()}
                </span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Location Tabs */}
      <section className="py-20 px-6 md:px-14 bg-[#0A0F0B]">
        <div className="max-w-7xl mx-auto">
          {/* Tab switcher */}
          <div className="flex flex-wrap gap-3 mb-12">
            {LOCATIONS.map((l) => (
              <button
                key={l.id}
                onClick={() => setActive(l.id)}
                className={`flex items-center gap-3 px-6 py-3 rounded-xl text-sm font-bold transition-all ${
                  active === l.id
                    ? "bg-[#1B5E35] text-[#F4F6F0]"
                    : "bg-[#111A14] text-[#6B7C6E] border border-[#1B5E35]/10 hover:text-[#F4F6F0]"
                }`}
              >
                <span className="text-xl">{l.flag}</span>
                <span>{l.city}</span>
                <span
                  className={`text-[10px] font-mono px-2 py-0.5 rounded-full ${
                    active === l.id
                      ? "bg-[#F4F6F0]/20"
                      : "bg-[#1B5E35]/20 text-[#2A7D4A]"
                  }`}
                >
                  {l.type === "Global Headquarters" ? "HQ" : "Franchise"}
                </span>
              </button>
            ))}
          </div>

          {/* Location detail */}
          <div className="grid md:grid-cols-2 gap-0 rounded-2xl overflow-hidden border border-[#1B5E35]/15">
            <div className="relative overflow-hidden min-h-72">
              <img loading="lazy" decoding="async"
                src={loc.img}
                alt={loc.city}
                className="w-full h-full object-cover"
              />
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(to top, rgba(10,15,11,0.85) 0%, transparent 50%), linear-gradient(to right, transparent 60%, #0A0F0B 100%)",
                }}
              />
              <div className="absolute bottom-6 left-6">
                <div className="text-5xl mb-2">{loc.flag}</div>
                <div
                  className="font-black text-[#F4F6F0] text-2xl"
                  style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
                >
                  {loc.city.toUpperCase()}
                </div>
                <div className="text-xs text-[#6B7C6E] font-mono tracking-widest">
                  {loc.type.toUpperCase()}
                </div>
              </div>
            </div>
            <div className="bg-[#0A0F0B] p-10 md:p-12">
              <div className="text-xs text-[#1B5E35] font-mono tracking-widest mb-4">
                {loc.label}
              </div>
              <p className="text-[#6B7C6E] leading-relaxed mb-8">{loc.desc}</p>

              <div className="space-y-4 mb-8">
                {[
                  { icon: "📍", label: loc.address },
                  { icon: "📞", label: loc.phone },
                  { icon: "✉️", label: loc.email },
                  { icon: "🕐", label: loc.hours },
                ]
                  .filter(({ label }) => label)
                  .map(({ icon, label }) => (
                    <div key={label} className="flex items-start gap-3 text-sm">
                      <span className="flex-shrink-0">{icon}</span>
                      <span className="text-[#F4F6F0]/80">{label}</span>
                    </div>
                  ))}
              </div>
              {loc.id === "uganda" && <WhatsAppButtons className="-mt-4 mb-8" />}

              <div className="mb-8">
                <div className="text-xs text-[#6B7C6E] font-mono tracking-widest mb-3">
                  SERVICES AT THIS OFFICE
                </div>
                <div className="flex flex-wrap gap-2">
                  {loc.services.map((s) => (
                    <span
                      key={s}
                      className="bg-[#1B5E35]/15 text-[#2A7D4A] text-xs font-mono px-3 py-1.5 rounded-full border border-[#1B5E35]/20"
                    >
                      {s}
                    </span>
                  ))}
                </div>
              </div>

              <Link
                to="/contact"
                className="inline-block bg-[#1B5E35] hover:bg-[#2A7D4A] text-[#F4F6F0] font-bold px-8 py-3 rounded-lg transition-colors text-sm"
              >
                Contact This Office →
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* All offices quick view */}
      <section className="py-16 px-6 md:px-14 bg-[#111A14] border-t border-[#1B5E35]/10">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2
              className="text-4xl font-black text-[#F4F6F0]"
              style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
            >
              ALL OFFICES AT A GLANCE
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {LOCATIONS.map((l) => (
              <button
                key={l.id}
                onClick={() => {
                  setActive(l.id)
                  window.scrollTo({ top: 0, behavior: "smooth" })
                }}
                className="bg-[#0A0F0B] border border-[#1B5E35]/10 hover:border-[#1B5E35]/50 rounded-2xl p-6 text-left transition-all group"
              >
                <div className="flex items-center justify-between mb-4">
                  <span className="text-3xl">{l.flag}</span>
                  <span className="text-[10px] font-mono text-[#1B5E35] border border-[#1B5E35]/30 px-2 py-1 rounded-full">
                    {l.type === "Global Headquarters" ? "HQ" : "Franchise"}
                  </span>
                </div>
                <div
                  className="font-black text-[#F4F6F0] text-xl mb-1 group-hover:text-[#2A7D4A] transition-colors"
                  style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
                >
                  {l.city}
                </div>
                <div className="text-xs text-[#6B7C6E] mb-3">{l.country}</div>
                <div className="text-xs text-[#6B7C6E]">{l.phone}</div>
                <div className="text-xs text-[#6B7C6E] break-all">
                  {l.email}
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}
